import moment from "moment";
import React, { useEffect, useState } from "react";
import { BiChevronUp, BiEdit, BiSave } from "react-icons/bi";
import { FcCalendar, FcClock } from "react-icons/fc";
import { theme } from "../../utils/theme";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { db } from "../../config/firebase-config";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useRef } from "react";
import { getCurrentUser } from "../../services/UserService"
import { partialUpdateMeetings, fetchMeetings } from "../../services/MeetingService"
import { fetchBotMeetings, partialUpdateUserBotMeetings } from "../../services/UserBotMeetingService"
import { getAllUserCalendarMeetings, partialUpdateUserCalendarMeetings } from "../../services/UserCalendarMeetingService"

const CardTask = ({ group, data, idx, completed }) => {
  const { calendarMeetings, meetings } = useSelector(
    (state) => state.meetingsReducer
  );
  const { uploads } = useSelector((state) => state.uploadsReducer);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const dispatch = useDispatch();
  const taskRef = useRef(null);
  const taskNameRef = useRef(null);
  const [taskName, setTaskName] = useState({
    name: data?.shortName || ` --task ${idx + 1}-- `,
    editing: false,
  });

  const refetchUploads = async () => {
    fetchMeetings(dispatch);
  };

  const fetchCalendarMeetings = async () => {
    let user = getCurrentUser();
    const meetSnaps = await getAllUserCalendarMeetings(user.uid, { "order_by": "createdAt", "order": "desc" },
      (response) => {
        return response.data;
      },
      (error) => {
          console.log("error: ", error);
          return [];
      }
    );
    const arr = [];
    meetSnaps?.forEach((snap) => {
      arr.push({ ...snap, id: snap.id });
    });
    import("../../redux/actions/meetingsActions").then((ac) =>
      dispatch(ac.setCalendarMeetings(arr))
    );
  };

  return (
    <div
      ref={taskRef}
      className="border rounded-md p-[10px] md:p-[20px] my-[10px] relative"
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center flex-wrap gap-[10px]">
          <div className="min-w-fit flex items-center gap-[5px]">
            {data?.shortName ? (
              taskName.editing ? (
                <input
                  ref={taskNameRef}
                  value={taskName.name}
                  onChange={(e) => {
                    setTaskName((val) => {
                      return { ...val, name: e.target.value };
                    });
                  }}
                  className="text-gray-500 text-xs md:text-sm 2xl:text-base outline-none w-[100px]"
                  id="TaskName"
                  placeholder="Add Task ShortName"
                />
              ) : (
                data?.shortName
              )
            ) : (
              <input
                ref={taskNameRef}
                disabled={!taskName.editing}
                value={taskName.name}
                onChange={(e) => {
                  setTaskName((val) => {
                    return { ...val, name: e.target.value };
                  });
                }}
                className="text-gray-500 text-xs md:text-sm 2xl:text-base outline-none w-[100px]"
                id="HashTag"
                placeholder="Add Task ShortName"
              />
            )}
            {taskName.editing ? (
              <BiSave
                onClick={() => {
                  if (group.taskType === "uploads") {
                    const newTasks = group.tasks;
                    newTasks[idx] = {
                      ...newTasks[idx],
                      shortName: taskName.name,
                    };
                    const newParticipants = group.participants;
                    newParticipants[group.participant] = {
                      ...newParticipants[group.participant],
                      tasks: newTasks,
                    };
                    
                    partialUpdateMeetings(group.id, { participants: newParticipants })
                    
                    const newUploads = uploads;
                    newUploads[group.idx] = {
                      ...newUploads[group.idx],
                      participants: newParticipants,
                    };
                    import("../../redux/actions/uploadsActions")
                      .then((ac) => dispatch(ac.setUploads(newUploads)))
                      .then(() => {
                        toast.success("Short name saved for task!");
                        setTaskName((val) => {
                          return { ...val, editing: false };
                        });
                      });
                  } else if (group.taskType === "botMeetings") {
                    const newTasks = group.tasks;
                    newTasks[idx] = {
                      ...newTasks[idx],
                      shortName: taskName.name,
                    };

                    let user = getCurrentUser();
                    partialUpdateUserBotMeetings(user.uid, group.id, {
                      tasks: newTasks,
                    })
                    const newMeetData = meetings;
                    newMeetData[group.idx] = {
                      ...newMeetData[group.idx],
                      tasks: newTasks,
                    };
                    import("../../redux/actions/meetingsActions")
                      .then((ac) => dispatch(ac.setMeetings(newMeetData)))
                      .then(() => {
                        toast.success("Short name saved for task!");
                        setTaskName((val) => {
                          return { ...val, editing: false };
                        });
                      });
                  } else if (group.taskType === "calendarMeetings") {
                    const newTasks = group.tasks;
                    newTasks[idx] = {
                      ...newTasks[idx],
                      shortName: taskName.name,
                    };

                    let user = getCurrentUser();
                    partialUpdateUserCalendarMeetings(user.uid, group.id, {
                      tasks: newTasks,
                    })
                    const newMeetData = calendarMeetings;
                    newMeetData[group.idx] = {
                      ...newMeetData[group.idx],
                      tasks: newTasks,
                    };
                    import("../../redux/actions/meetingsActions")
                      .then((ac) =>
                        dispatch(ac.setCalendarMeetings(newMeetData))
                      )
                      .then(() => {
                        toast.success("Short name saved for task!");
                        setTaskName((val) => {
                          return { ...val, editing: false };
                        });
                      });
                  }
                }}
                title="Save"
                className="cursor-pointer"
              />
            ) : (
              <BiEdit
                title="Edit"
                className="cursor-pointer"
                onClick={() => {
                  setTaskName((val) => {
                    return { ...val, editing: true };
                  });
                  taskNameRef.current?.focus();
                }}
              />
            )}
          </div>
        </div>
        <div>
          <div
            onClick={() => {
              setOpen(!open);
            }}
            className="cursor-pointer flex gap-[5px] items-center text-[#6b7b8a] lg:text-sm xl:text-base 2xl:text-lg text-xs"
          >
            Details
            <BiChevronUp
              className={`text-black sm:text-xl transition ${
                open ? "rotate-180" : "rotate-90"
              }`}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-[10px] items-center text-xs lg:text-sm 2xl:text-base">
        <div className="">
          {group.taskType === "uploads" ? group.fileDetails.name : group.name}
        </div>
        <div className="text-[#07457f]">
          {group.taskType === "uploads"
            ? group?.fileDetails?.hashTag
            : group?.hashTag}
        </div>
      </div>
      <div className="flex items-center gap-[10px] 2xl:text-base xl:text-sm text-xs my-[10px]">
        <div className="flex items-center gap-[5px]">
          <div>
            <FcCalendar className="h-[20px] w-[20px]" />
          </div>
          <div className="text-[#19324B]">
            {moment(moment(group?.createdAt)?.toDate()).format("ddd, MMM DD")}
          </div>
        </div>
        <div className="flex items-center gap-[5px]">
          <div>
            <FcClock className="h-[20px] w-[20px]" />
          </div>
          <div className="text-[#19324B]">
            {moment(moment(group?.createdAt)?.toDate()).format("hh:mm A")}
          </div>
        </div>
      </div>
      {open && (
        <div className="fade my-[10px] text-sm lg:text-base">{data.name}</div>
      )}
      <div className="flex gap-[10px] items-center">
        <div
          onClick={() => {
            if (!completed) {
              let user = getCurrentUser();
              setLoading(true);
              const newTasks = group.tasks;
              newTasks[idx] = { ...newTasks[idx], taskDone: !data.taskDone };
              if (group.taskType === "uploads") {
                const newParticipants = group.participants;
                newParticipants[group.participant] = {
                  ...newParticipants[group.participant],
                  tasks: newTasks,
                };
                
                partialUpdateMeetings(group.id,
                  {
                    participants: newParticipants
                  },
                  (response) => {
                    refetchUploads();
                    setLoading(false);
                  }
                )
              } else if (group.taskType === "botMeetings") {
                partialUpdateUserBotMeetings(user.uid, group.id, { tasks: newTasks },
                  (response) => {
                    fetchBotMeetings(dispatch);
                    setLoading(false);
                  }
                )
              } else if (group.taskType === "calendarMeetings") {
                partialUpdateUserCalendarMeetings(user.uid, group.id, { tasks: newTasks },
                  (response) => {
                    fetchBotMeetings(dispatch);
                    setLoading(false);
                  }
                )
              }
            }
          }}
          style={
            completed
              ? { backgroundColor: "#197542", cursor: "default" }
              : { backgroundColor: theme.color, cursor: "pointer" }
          }
          className="s25-step rounded-md text-white py-[5px] px-[10px] lg:text-base sm:text-sm text-xs"
        >
          {loading ? (
            <CircularProgress
              style={{ width: "20px", height: "20px", color: "white" }}
            />
          ) : completed ? (
            "Completed"
          ) : (
            "Mark Complete"
          )}
        </div>
        <div
          onClick={() => {
            setConfirmDelete(true);
          }}
        >
          <button className="s26-step text-[red] py-[5px] px-[10px] lg:text-sm text-xs">
            Delete
          </button>
        </div>
      </div>
      {confirmDelete && (
        <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-40 justify-center items-center">
          <div className="w-fit flex flex-col items-end modalAnimation max-w-[85%]">
            <div
              onClick={() => {
                setConfirmDelete(false);
              }}
              className="bg-white cursor-pointer z-30 mb-[10px] w-fit rounded-full p-[2px]"
            >
              <IoClose />
            </div>
            <div
              className={`rounded-md bg-white border-box relative p-[15px] max-h-[85vh] text-sm sm:text-base w-[300px] overflow-auto overflow-x-hidden`}
            >
              <div className="">Are you sure you want to delete it?</div>
              <button
                onClick={() => {
                  let user = getCurrentUser();
                  setConfirmDelete(false);
                  taskRef.current.classList.add("deleteAnimation");
                  const newTasks = group.tasks;
                  newTasks[idx] = { ...newTasks[idx], taskDeleted: true };
                  if (group.taskType === "uploads") {
                    const newParticipants = group.participants;
                    newParticipants[group.participant] = {
                      ...newParticipants[group.participant],
                      tasks: newTasks,
                    };

                    partialUpdateMeetings(group.id,
                      {
                        participants: newParticipants
                      },
                      (response) => {
                        toast.info("Task deleted!");
                        refetchUploads();
                      }
                    )
                  } else if (group.taskType === "botMeetings") {
                    partialUpdateUserBotMeetings(user.uid, group.id, { tasks: newTasks },
                      (response) => {
                        toast.info("Task deleted!");
                        fetchBotMeetings(dispatch);
                      }
                    )
                  } else if (group.taskType === "calendarMeetings") {
                    partialUpdateUserCalendarMeetings(user.uid, group.id, { tasks: newTasks },
                      (response) => {
                        toast.info("Task deleted!");
                        fetchCalendarMeetings();
                      }
                    )
                  }
                }}
                className="py-[5px] w-fit px-[20px] mt-[10px] float-right bg-red-500 text-white rounded-md flex items-center justify-center"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardTask;
